import { isWithinInterval, subMonths, parseISO } from 'date-fns';
import { languageToLocale } from '@spa/shared/utils';

export const getResultOffer = ({ id, attributes }, isResidences = false) => {
  const offerAttributes = isResidences && attributes.offers?.length ? attributes.offers[0] : attributes;

  const {
    accommodation_offer: {
      all_bills_included: allBillsIncluded,
      available_from: availableFrom,
      max_guests: maxGuests,
      title: offerTitle,
      price: { amount, currency_code: currencyCode },
      old_price: oldPrice,
      reviews_average: reviewsRating,
      exclusive: isExclusive,
      is_instant_booking: isInstantBooking,
      created_at: createdAt,
      is_sold_out: isSoldOut
    },
    property: {
      id: propertyId,
      title: propertyTitle,
      neighbourhood: { name: neighbourhood } = {},
      number_of_bathrooms: numberOfBathrooms,
      number_of_rooms: numberOfRooms,
      rent_by: rentBy,
      verified: isVerified,
      building: building,
      photos: propertyPhotos = []
    },
    accommodation_provider: {
      verifications: { trusted: isTrusted }
    },
    photos = []
  } = offerAttributes;

  const title = isResidences ? propertyTitle || offerTitle : offerTitle;

  return {
    id,
    propertyId,
    title,
    maxGuests,
    availableFrom: new Date(availableFrom),
    allBillsIncluded,
    rent: { amount, currencyCode },
    oldRent: oldPrice ? { amount: oldPrice.amount, currencyCode: oldPrice.currency_code } : null,
    neighbourhood,
    numberOfBathrooms,
    numberOfRooms,
    rentBy,
    building,
    reviewsRating,
    isExclusive,
    isInstantBooking,
    isVerified,
    isTrusted,
    isSoldOut,
    isNew: isNew(createdAt),
    photos: transformPhotosUrl(isResidences && propertyPhotos.length ? propertyPhotos : photos)
  };
};

export const getStaticOffer = (
  {
    id,
    titles,
    maxGuests,
    availableFrom,
    isBillsIncluded: allBillsIncluded,
    price,
    currencyCode,
    countBedrooms: numberOfRooms,
    rentBy,
    exclusive: isExclusive,
    instant_booking: isInstantBooking,
    checked: isVerified,
    trusted_landlord: isTrusted,
    photos
  },
  language
) => {
  return {
    id,
    propertyId: null,
    title: titles[languageToLocale(language)],
    maxGuests,
    availableFrom: new Date(availableFrom),
    allBillsIncluded,
    rent: { amount: price * 100, currencyCode },
    oldRent: null,
    neighbourhood: '',
    numberOfRooms,
    rentBy,
    reviewsRating: 0,
    isExclusive,
    isInstantBooking,
    isVerified,
    isTrusted,
    isSoldOut: false,
    isNew: false,
    photos,
    building: null
  };
};

export const isNew = createdAt => {
  const now = Date.now();
  const oneMonthAgo = subMonths(now, 1);

  return isWithinInterval(parseISO(createdAt), { start: oneMonthAgo, end: now });
};

export const transformPhotosUrl = (photos, size = 'small') =>
  photos.reduce((acc, { placeholder, hash }) => {
    if (placeholder) {
      return acc;
    }

    return [...acc, { hash, path: `${process.env.CDN_PHOTOS_URL}/property-photos/${hash}/${size}.jpg` }];
  }, []);
